let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gLWOP")).then(() => parcelRequire('bupB5'));